import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon3dPackage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-Icon3dPackage"><Path d="M12.0018 1.75L20.8785 6.875V17.125L12.0018 22.25L3.125 17.125V6.875L12.0018 1.75Z" stroke="currentColor"/><Path d="M20.8785 6.875L12.0018 12M12.0018 22.25V12M3.125 6.875L12.0018 12" stroke="currentColor"/><Path d="M7.5625 4.3125L16.4393 9.4375" stroke="currentColor"/></CentralIconBase>;
});

export default Icon3dPackage;
